import {
  BillingPaymentPeriod,
  BillingPaymentsPayment,
  BillingPaymentStatus,
} from "../types/billing";

export const BILLING_PAYMENT_STATUS_DISPLAY_ORDER = [
  BillingPaymentStatus.Overdue,
  BillingPaymentStatus.Unpaid,
  BillingPaymentStatus.Upcoming,
  BillingPaymentStatus.Paid,
];

export const BILLING_PAYMENT_STATUS_PAID_STATUSES = [
  BillingPaymentStatus.Paid,
  BillingPaymentStatus.Upcoming,
];

export const UNPAID_PAYMENT: BillingPaymentsPayment = {
  amount: 0,
  dueDate: null,
  paymentDate: null,
  period: BillingPaymentPeriod.Annual,
  status: BillingPaymentStatus.Unpaid,
};
